export enum DateAndValueXYChartUnitEnum {
    CURRENCY = 'CURRENCY',
    NUMBER = 'NUMBER',
    PROMINENCE_LEVELS = 'PROMINENCE_LEVELS',
    PERCENTAGE = 'PERCENTAGE',
}
